/**
 * Bingo Scheduler Controls View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Form = require('class/form.class');
    var BingoSchedulerControlsModel = require('portlets/bingo-scheduler/bingo-scheduler.controls.model');
    var BaseView = require('common/base.view');
    var device = require('util/device.util');
    var core = require('core');

    module.exports = BaseView.extend({

        events: {
            'tap .fn-view-mode-item': 'handleViewModeChange',
            'change .fn-bingo-filter': 'handleFilterChange',
        },

        initialize: function(options) {
            this.options = options;
            this.model = new BingoSchedulerControlsModel(this.options);
        },

        subscribe: function() {
            this.model.on('change:rooms', this.render.bind(this));
            this.listenToOnce(core, 'page:rendered', this._wrapElements);
        },

        /**
         * Change game portlet view mode
         * @param {Event} e
         */
        handleViewModeChange: function(e) {
            this.$('.fn-view-mode-item.active').removeClass('active');
            e.currentTarget.classList.add('active');

            core.trigger('bingoScheduler:changeViewMode', e.currentTarget.dataset.viewMode);
        },

        handleFilterChange: function(e) {
            this.filterChange(e.currentTarget.value, e.currentTarget.id);
        },

        filterChange: function(value, filterMethod) {
            core.trigger('bingoScheduler:changeFilter', [
                filterMethod,
                this.model.get(filterMethod).serverMap[value]
            ]);
        },

        render: function() {
            this.$el.html(
                this.tmpl(
                    'bingo-scheduler.controls',
                    _.extend(
                        {},
                        this.options.config,
                        this.model.toJSON(),
                        {formFactor: device.formFactor}
                    )
                )
            );

            this._wrapElements();

            return this;
        },

        _wrapElements: function() {
            Form.prototype.wrapFormControls(this.$el);
        }

    });
});
